import React from 'react';
import { BlueLink, YellowButton } from './buttons';
import { dummyClick } from './utilities';

const ConfirmationModal = ({ title, confirm, cancel, onConfirm, onCancel, className, style }) => (
  <div
    className={`absolute f--2 shadow-1 t-pa2 bg-white ${className}`}
    style={mergeWithDefault('style', style)}
  >
    <h2 className="f-0 t-mt1 t-mb3">{title}</h2>
    <YellowButton text={confirm} onClick={onConfirm} />
    <BlueLink text={cancel} className="ttu t-ml3 f--3" onClick={onCancel} />
  </div>
);

const mergeWithDefault = (attr, param) => Object.assign({}, ConfirmationModal.defaultProps[attr], param);

ConfirmationModal.defaultProps = {
  title: 'EN Please confirm the action',
  confirm: 'EN Delete',
  cancel: 'EN Cancel',
  onConfirm: dummyClick,
  onCancel: dummyClick,
  className: '',
  style: {
    width: '250px',
    height: '120px',
    zIndex: 100,
    top: '22px',
    right: '8px'
  }
};

export default ConfirmationModal;
